module.exports = __webpack_public_path__ + "img/new_00.e85ff626.jpg";